'use strict';
import JWT from './JWT';

const isSuperAdmin = (token) => {

    if (!token) {
        return false;
    }

    let decoded = JWT.decode(token);
    if (!decoded) {
        return false
    }

    return decoded.isSuperAdmin === true;
}

export default isSuperAdmin;